import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import About from "@/pages/about/page";
import Process from "@/pages/process/page";
import Collections from "@/pages/collections/page";
import RequestDiamond from "@/pages/request-diamond/page";
import Contact from "@/pages/contact/page";
import Terms from "@/pages/terms/page";
import FAQ from "@/pages/faq/page";
import PrivacyPolicy from "@/pages/privacy-policy/page";
import DiamondEducation from "@/pages/diamond-education/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/about", element: <About /> },
  { path: "/process", element: <Process /> },
  { path: "/collections", element: <Collections /> },
  { path: "/request-a-diamond", element: <RequestDiamond /> },
  { path: "/contact", element: <Contact /> },
  { path: "/faq", element: <FAQ /> },
  { path: "/diamond-education", element: <DiamondEducation /> },
  { path: "/terms-and-conditions", element: <Terms /> },
  { path: "/privacy-policy", element: <PrivacyPolicy /> },
  { path: "*", element: <NotFound /> },
];

export default routes;